// Keep the inset in the document even when PDF export requests zero page margins.
export const simausPrintStyle = `@media print {
  @page { size: A4 landscape; margin: 0; }
  html:has(.simaus-print-document), body:has(.simaus-print-document),
  #root:has(.simaus-print-document), .app-layout:has(.simaus-print-document) {
    margin: 0 !important; padding: 0 !important;
    min-height: 0 !important; height: auto !important;
  }
  .app-layout:has(.simaus-print-document) > :not(.simaus-print-document) {
    display: none !important;
  }
  #root:has(.simaus-print-document) > :not(.app-layout) { display: none !important; }
  .simaus-print-document {
    page: auto; position: static !important;
    width: 100% !important; max-width: 100% !important;
    margin: 0 !important; padding: 12mm !important;
    box-sizing: border-box;
    -webkit-box-decoration-break: clone; box-decoration-break: clone;
  }
  .simaus-print-document .no-print { display: none !important; }
  .simaus-print-document table { width: 100% !important; }
  .simaus-print-document th, .simaus-print-document td {
    min-width: 0 !important; max-width: none !important;
    white-space: normal !important; overflow-wrap: anywhere !important;
  }
  .simaus-print-document thead { display: table-header-group !important; }
  .simaus-print-document tr { break-inside: avoid; }
}`;
